import { render, staticRenderFns } from "./CalculationCreate.vue?vue&type=template&id=cf13ab2a&scoped=true&"
import script from "./CalculationCreate.vue?vue&type=script&lang=js&"
export * from "./CalculationCreate.vue?vue&type=script&lang=js&"
import style0 from "./CalculationCreate.vue?vue&type=style&index=0&id=cf13ab2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf13ab2a",
  null
  
)

export default component.exports